



























import {
  Component,
  Prop,
  Vue,
  Watch,
  Model,
  PropSync,
} from 'vue-property-decorator';
import { Scope } from 'spraypaint';
import { ApplicationRecord } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  // eg [{ value: 'id', text: 'ID' }]
  @Prop({ required: true }) readonly headers: any[];

  @Prop({ required: true }) readonly singleSelect: boolean;

  @Prop({}) readonly search: boolean;

  @Prop({ default: () => ({}) }) readonly defaultOptions: any;

  // Extra `filter[...]` params, on top of the search box - eg
  // `{ is_verified: 'false' }`. Values that are empty are dropped rather than
  // sent: an unknown or unparseable filter is a 400 from Django, not a
  // silently ignored parameter.
  @Prop({ default: () => ({}) }) readonly filters: { [key: string]: string };

  // eg () => User.includes(['someFields']).where({ project: 1 });
  @Prop({ required: true }) readonly scopeFactory: () => Scope<
    ApplicationRecord
  >;

  @PropSync('selected', { default: () => [] })
  syncedSelected!: ApplicationRecord[];

  // selected: ApplicationRecord[] = [];

  loading: boolean = false;

  total: number = 0;

  items: ApplicationRecord[] = [];

  options = {
    sortBy: [],
    sortDesc: [],
    page: 1,
    itemsPerPage: 80,
  };

  footerProps = {
    'items-per-page-options': [20, 40, 80, 150],
  };

  itemClicked(item: ApplicationRecord) {
    this.$emit('item-clicked', item);
  }

  get activeFilters() {
    const active: { [key: string]: string } = {};
    Object.keys(this.filters).forEach(key => {
      const value = this.filters[key];
      if (value !== '' && value !== null && value !== undefined) {
        active[key] = value;
      }
    });
    return active;
  }

  async update() {
    this.loading = true;
    try {
      const itemsPerPage =
        this.options.itemsPerPage === -1 ? 10000 : this.options.itemsPerPage;
      // initial scope + page + pageSize
      let scope = this.scopeFactory()
        .where({ search: this.search, ...this.activeFilters })
        .page(this.options.page)
        .per(itemsPerPage);

      // order by
      this.options.sortBy.forEach((sort, i) => {
        const order: any = {};
        order[sort] = this.options.sortDesc[i] ? 'desc' : 'asc';
        scope = scope.order(order);
      });

      // // handle where clause ?!

      // get result
      const result = await scope.all();
      this.items = result.data;
      this.total = result.meta.pagination.count;
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  created() {
    this.options = { ...this.options, ...this.defaultOptions };
  }

  @Watch('options', { deep: true })
  optionsChanged() {
    this.update();
  }

  // Changing a filter goes back to page 1: page 3 of "all users" is usually
  // past the end of "unverified users", which would otherwise read as an empty
  // list. Resetting the page fires the options watcher, so only reload here
  // when the page was already 1 and nothing else will.
  @Watch('filters', { deep: true })
  filtersChanged() {
    if (this.options.page !== 1) {
      this.options.page = 1;
      return;
    }
    this.update();
  }
}
